import Geocode from "react-geocode";
import { v1 as uuidv1 } from 'uuid';

import { db, storage } from "firebase/fbConfig.js";
import { isEmail, isPhoneNumber } from "store/actions/formActions.jsx";

Geocode.setApiKey("AIzaSyDKrlqKEz5EdVwdJQA5tasUAIurZ_jsYNM");

const orderRef = db.collection('haney-orders');

const createError = (error, msg) => ({
    error,
    msg
});

export const getMilitaryTime = ({ date, hours, minutes }) => {
    if (hours) {
        const dt = new Date(date.getFullYear(), date.getMonth(), date.getDate());

        const newMinutes = minutes ? parseInt(minutes) + (parseInt(hours) * 60) : parseInt(hours) * 60;
        return new Date(dt.getTime() + (newMinutes * 60000));
    } else {
        return date;
    }
}

export const getCoords = async (party) => {
    const res = await Geocode.fromAddress(`${party.city} ${party.state}`)
    console.log(res);
    return res.results[0].geometry.location
}

export const billingToParty = (orderData) => {
    switch (orderData.billingParty) {
        case 'Shipper':
            return orderData.origin;

        case 'Consignee':
            return orderData.destination;

        case 'Third Party':
            return orderData.thirdParty;
    }
}

export const checkBilling = (party) => {
    const req = [
        { key: 'firstName', label: 'first name' },
        { key: 'lastName', label: 'last name' },
        { key: 'email', label: 'email' },
        { key: 'phone', label: 'phone number' }
    ];

    const missing = req.filter(r => {
        if (r.key === 'email') {
            return !isEmail(party[r.key]);
        } else if (r.key === 'phone') {
            return !(party[r.key] && isPhoneNumber(party[r.key]));
        } else {
            return !party[r.key];
        }
    });

    if (missing.length) return createError({
        keys: missing
    }, missing.map(r => r.label).join(', '));
}

export const checkParty = (party) => {
    if (!party) return createError('No party provided', 'No party provided.');

    const req = [
        { key: 'businessName', label: 'business name' },
        { key: 'address', label: 'address' },
        { key: 'city', label: 'city' },
        { key: 'state', label: 'state' },
        { key: 'zip', label: 'zip' }
    ];

    const missing = req.filter(r => !party[r.key]);

    if (missing.length) return createError({
        keys: missing
    }, missing.map(r => r.label).join(', '))
}

export const checkItems = (items) => {
    if (!(items && items.length)) return createError('No items provided', 'No items provided.');

    const getReq = (item) => {
        const baseReq = [
            { key: 'packaging', label: 'packaging' },
            { key: 'quantity', label: 'quantity' },
            { key: 'weight', label: 'weight' },
            { key: 'length', label: 'length' },
            { key: 'description', label: 'description' }
        ];

        if (item.isHazmat) baseReq.push(
            { key: 'unNumber', label: 'UN Number' },
            { key: 'properShippingName', label: 'proper shipping name' }
        );

        if (!item.isFootage) baseReq.push(
            { key: 'width', label: 'width' },
            { key: 'height', label: 'height' },
        )

        return baseReq;
    }


    const errors = items.map((item, i) => {
        const req = getReq(item)

        const missing = req.filter(r => !item[r.key]);

        if (missing.length) return createError({
            item: i,
            keys: missing
        }, `Item #${i + 1}: ${missing.map(r => r.label).join(', ')}.`);

        return null;
    }).filter(Boolean);

    if (errors.length) return errors;
    return;
}

export const checkBasic = (orderData) => {
    const req = [
        { key: 'billingParty', label: 'billing party' }
    ];

    const missing = req.filter(r => !orderData[r.key]);

    if (missing.length) return createError({ keys: missing }, missing.map(r => r.label).join(', '));

    return null;
}

function* orderCounter() {
    const counter = orderRef.doc('order-counter');

    const count = yield counter.get();

    console.log(count);

    yield counter.set({
        count,
        updatedAt: new Date()
    }, { merge: true });
}

export const createStatus = (id, statusData = {}, user = { firstName: 'None', lastName: 'Given', id: 'N/a' }) => orderRef.doc(id).collection('statusLogs').add({
    updatedAt: new Date(),
    updatedBy: { name: `${user.firstName} ${user.lastName}`, uid: user.uid },
    ...statusData
})

export const uploadPic = (pic, refString, meta) => new Promise((resolve, reject) => {
    const storageRef = storage.ref(refString);
    // upload pic
    const uploadTask = storageRef.put(pic);
    // update progress bar
    uploadTask.on('state_changed', (snapshot) => {
        console.log(snapshot);
        // Observe state change events such as progress, pause, and 
        // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
    }, (error) => {
        // Handle unsuccessful uploads
        console.log(error)
    }, () => {
        // Handle successful uploads on complete
        // For instance, get the download URL: https://firebasestorage.googleapis.com/...
        uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
            resolve({
                ...meta,
                picURL: downloadURL
            })
        });
    })
})

export const uploadItemImages = (items, id) => new Promise((resolve, reject) => {
    const promises = [];
    for (let i = 0; i < items.length; i++) {
        const item = items[i]

        if (!item.files) continue;

        for (let j = 0; j < item.files.length; j++) {
            const { file } = item.files[j];
            const imageID = uuidv1();

            promises.push(
                uploadPic(file, `orders/${id}/${i}/${imageID}`, { id: imageID })
            );
        }
    }

    Promise.all(promises)
        .then(results => {
            let count = 0;
            const itemsNoFiles = items.map(item => {
                if (item.files) {
                    item.files = results.slice(count, count + item.files.length);
                    count += item.files.length;
                }

                return item
            });

            return orderRef.doc(id).set({
                items: itemsNoFiles
            }, { merge: true });
        })
        .then(resolve)
        .catch(reject);
})

export const createOrder = (orderData, user) => new Promise(async (resolve, reject) => {
    const orderCounterGen = orderCounter();

    const countSnap = await orderCounterGen.next().value;
    const count = Number(countSnap.get('count')) + 1;

    const itemsNoFiles = orderData.items.map(({ files, ...noFiles }) => noFiles);

    let entityIDs

    if (orderData.thirdParty) {
        if (orderData.thirdParty.city) {
            entityIDs = ['origin', 'destination', 'thirdParty'].map(party => orderData[party].entityID || null);
        } else {
            entityIDs = ['origin', 'destination'].map(party => orderData[party].entityID || null);
        }
        
    } else {
        entityIDs = ['origin', 'destination'].map(party => orderData[party].entityID || null);
    }

    console.log(entityIDs)
    
    const now = new Date();

    let newOrder
    
    if (orderData.thirdParty) {

    if (orderData.thirdParty.city) {
        newOrder = {
            appCreatedIn: 'Customer',
            uid: orderData.uid,
            user: user ? user : null,
            freightBillNumber: count,
            role: orderData.role,
            status: "Pending",
            billingParty: orderData.billingParty,
            origin: orderData.origin,
            originLat: orderData.originLat ? orderData.originLat : null,
            originLng: orderData.originLng ? orderData.originLng : null,
            pickUpAPI: orderData.pickUpAPI ? orderData.pickUpAPI : null,
            pickUpServices: orderData.pickUpServices ? orderData.pickUpServices : null,
            destinationLat: orderData.destinationLat ? orderData.destinationLat : null,
            destinationLng: orderData.destinationLng ? orderData.destinationLng : null,
            destination: orderData.destination,
            groups: (orderData.groups && orderData.groups.length) ? orderData.groups : ["bpn6FBAqZiV3e8mMNWJd"],
            thirdParty: orderData.thirdParty ? orderData.thirdParty : {},
            items: itemsNoFiles,
            deliveryType: orderData.deliveryType ? orderData.deliveryType : null,
            flightNumber: orderData.flightNumber ? orderData.flightNumber : null,
            shipperID: user.shipperID ? user.shipperID : null,
            shipperName: null,
            entityIDs: entityIDs,
            test: false,
            page: window.location.pathname,
            updatedAt: now,
            createdAt: now
        }
    } else {
        newOrder = {
            appCreatedIn: 'Customer',
            uid: orderData.uid,
            user: user ? user : null,
            freightBillNumber: count,
            role: orderData.role,
            status: "Pending",
            billingParty: orderData.billingParty,
            origin: orderData.origin,
            originLat: orderData.originLat ? orderData.originLat : null,
            originLng: orderData.originLng ? orderData.originLng : null,
            pickUpAPI: orderData.pickUpAPI ? orderData.pickUpAPI : null,
            pickUpServices: orderData.pickUpServices ? orderData.pickUpServices : null,
            destinationLat: orderData.destinationLat ? orderData.destinationLat : null,
            destinationLng: orderData.destinationLng ? orderData.destinationLng : null,
            destination: orderData.destination,
            groups: (orderData.groups && orderData.groups.length) ? orderData.groups : ["bpn6FBAqZiV3e8mMNWJd"],
            items: itemsNoFiles,
            deliveryType: orderData.deliveryType ? orderData.deliveryType : null,
            flightNumber: orderData.flightNumber ? orderData.flightNumber : null,
            shipperID: user.shipperID ? user.shipperID : null,
            shipperName: null,
            entityIDs: entityIDs,
            test: false,
            page: window.location.pathname,
            updatedAt: now,
            createdAt: now
        }
    }

} else {

    newOrder = {
        appCreatedIn: 'Customer',
        uid: orderData.uid,
        user: user ? user : null,
        freightBillNumber: count,
        role: orderData.role,
        status: "Pending",
        billingParty: orderData.billingParty,
        origin: orderData.origin,
        originLat: orderData.originLat ? orderData.originLat : null,
        originLng: orderData.originLng ? orderData.originLng : null,
        pickUpAPI: orderData.pickUpAPI ? orderData.pickUpAPI : null,
        pickUpServices: orderData.pickUpServices ? orderData.pickUpServices : null,
        destinationLat: orderData.destinationLat ? orderData.destinationLat : null,
        destinationLng: orderData.destinationLng ? orderData.destinationLng : null,
        destination: orderData.destination,
        groups: (orderData.groups && orderData.groups.length) ? orderData.groups : ["bpn6FBAqZiV3e8mMNWJd"],
        items: itemsNoFiles,
        deliveryType: orderData.deliveryType ? orderData.deliveryType : null,
        flightNumber: orderData.flightNumber ? orderData.flightNumber : null,
        shipperID: user.shipperID ? user.shipperID : null,
        shipperName: null,
        entityIDs: entityIDs,
        test: false,
        page: window.location.pathname,
        updatedAt: now,
        createdAt: now
    }

}

    console.log("neworder " + newOrder)
    orderRef.add(newOrder)
        .then(docRef => Promise.all([
            uploadItemImages(orderData.items, docRef.id),
            orderCounterGen.next(count),
            createStatus(
                docRef.id,
                {
                    status: 'Created / Pending',
                    type: 'status',
                    updatedAt: now
                },
                user
            )
        ]))
        .then(resolve)
        .catch(reject);
})


// WEBPACK FOOTER //
// ./src/store/actions/orderActions.js